<div class="card-base">
  <div class="card-content-reservation-search">
    <div class="chip-container">
      <mat-chip-list>
        <mat-chip
          color="accent"
          matTooltip="{{ filt.toolTip }}"
          selected
          *ngFor="let filt of searchFilters"
        >
          {{ filt.valueView }}
          <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()"
            >cancel</mat-icon
          >
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="card-container mat-elevation-z1">
      <div class="clearfix">
        <div class="pull-right div-header-right">
          <!-- <div id="totalized-container">
                        <div *ngFor="let item of totalized"> {{ item.text }} </div>
                    </div> -->
          <button
            *ngIf="!loadingAction"
            class="card-inline margin-top-medium"
            [matMenuTriggerFor]="menuItem"
            type="button"
            mat-mini-fab
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
          <mat-menu #menuItem="matMenu">
            <button (click)="setControled()" mat-menu-item>
              <span> <b>Controlado</b></span>
            </button>
            <button (click)="setObserved()" mat-menu-item>
              <span> <b>Observado</b></span>
            </button>
            <button (click)="rollBack()" mat-menu-item>
              <span> <b>Revertir</b></span>
            </button>
            <button (click)="viewReport()" mat-menu-item>
              <span> <b>Ver resumen</b></span>
            </button>
            <button (click)="export()" mat-menu-item>
              <span> <b>Exportar ERP</b></span>
            </button>
          </mat-menu>
        </div>
        <div class="pull-left div-header-left">
          <app-search-filter-component
            #searchFilter
            (startSearch)="onStartSearch()"
            (endSearch)="onEndSearch($event)"
            [filter]="filters"
          ></app-search-filter-component>
          <app-cash-desk-close-control-filter
            (onInitSearch)="onEndSearch($event)"
            #filters
          ></app-cash-desk-close-control-filter>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="card-content margin-botton-medium">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
          <table
            class="search-table search-table-fixed"
            mat-table
            [dataSource]="dataSource"
          >
            <ng-container matColumnDef="select" sticky>
              <th
                style="width: 70px"
                class="search-table-header"
                mat-header-cell
                *matHeaderCellDef
              >
                <mat-checkbox
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                >
                </mat-checkbox>
              </th>
              <td
                style="width: 70px"
                class="search-table-cell"
                mat-cell
                *matCellDef="let row"
              >
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="
                    $event ? selection.toggle(row) : null; checkItemChange()
                  "
                  [checked]="selection.isSelected(row)"
                >
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="closeNumber">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="70"
                  tile="Nro cierre"
                  #resColCloseNumber
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.CloseNumber }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="paymentDate">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="70"
                  tile="Fecha cobro"
                  #resColPaymentDate
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.PaymentDate | date : "dd/MM/yyyy" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="protocol">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="140"
                  tile="Protocolo"
                  #resColProtocol
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.Protocol }}
              </td>
            </ng-container>

            <ng-container matColumnDef="invoiceNumber">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="140"
                  tile="Factura"
                  #resColInvoiceNumber
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.InvoiceNumber }}
              </td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="70"
                  tile="Monto"
                  #resColAmount
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.Amount }}
              </td>
            </ng-container>
            <ng-container matColumnDef="cashDeskCloseStateName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="110"
                  tile="Estado"
                  #resColCashDeskCloseStateName
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.CashDeskCloseStateName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="serviceName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="140"
                  tile="Servicio"
                  #resColServiceName
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.ServiceName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="businessName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="140"
                  tile="Empresa"
                  #resColBusinessName
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.BusinessName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="observation">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="140"
                  tile="Observaciones"
                  #resColObservation
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                {{ element.Observation }}
              </td>
            </ng-container>

            <ng-container matColumnDef="star" stickyEnd>
              <th
                class="search-table-header"
                mat-header-cell
                *matHeaderCellDef
              ></th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">

                <button mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuItem="matMenu">
                  <button (click)="exportItem(element)" mat-menu-item>
                    <mat-icon>search</mat-icon><span>Exportar</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr
              mat-header-row
              class="search-table-header"
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              class="search-table-cell"
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </p-scrollPanel>
        <pager
          (selectedPageIndexChange)="selectedPageIndexChange($event)"
          #pager
        ></pager>
      </div>
    </div>
  </div>
</div>
